<div class="tab-content">
  <div class="content-header">
    <h2>Termékek Kezelése</h2>
    <app-add-new-button 
      text="Új termék" 
      (clicked)="openProductForm()">
    </app-add-new-button>
  </div>

  <!-- Insurance Company Tabs -->
  @if (insuranceCompanies.length > 0) {
    <div class="insurance-tabs-container">
      <nav class="insurance-tabs">
        @for (company of insuranceCompanies; track company.id) {
          <button 
            class="insurance-tab-button"
            [class.active]="selectedInsuranceCompanyId === company.id"
            (click)="selectInsuranceCompany(company.id)">
            <mat-icon>business</mat-icon>
            <span>{{ company.companyname }}</span>
          </button>
        }
      </nav>

      <!-- Selected Insurance Company Content -->
      @if (getSelectedInsuranceCompany(); as selectedCompany) {
        <div class="insurance-tab-content">
          <div class="card">
            <div class="card-header">
              <h3>{{ selectedCompany.companyname }} - Termékek</h3>
            </div>
            <div class="card-content">
              @if (products && products.length > 0) {
                <div class="products-table-container">
                  <table class="products-table">
                    <thead>
                      <tr>
                        <th>Módozat kód</th>
                        <th>Módozat neve</th>
                        <th>Típus</th>
                        <th>Műveletek</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (product of products; track product.id) {
                        <tr>
                          <td>{{ product.productcode }}</td>
                          <td>{{ product.productname }}</td>
                          <td>{{ product.producttype }}</td>
                          <td class="actions-column">
                            <app-edit-icon-button 
                              (clicked)="editProduct(product)"
                              tooltip="Termék szerkesztése"
                              color="primary">
                            </app-edit-icon-button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              } @else {
                <div class="no-products">
                  <mat-icon>inventory_2</mat-icon>
                  <p>Ehhez a biztosítóhoz még nincsenek termékek hozzáadva.</p>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="card">
      <div class="card-content">
        <p>Nincsenek biztosítók az adatbázisban. Kérjük, először adjon hozzá biztosítókat a Beállítások fülön.</p>
      </div>
    </div>
  }
</div>